import { render } from "./RfpCategoryForm.vue?vue&type=template&id=4cf491a7&scoped=true&ts=true"
import script from "./RfpCategoryForm.vue?vue&type=script&lang=ts"
export * from "./RfpCategoryForm.vue?vue&type=script&lang=ts"

import "./RfpCategoryForm.vue?vue&type=style&index=0&id=4cf491a7&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf491a7"]])

export default __exports__